import { message } from "antd";

export const copyToClipboard = async (value: string): Promise<void> => {
  try {
    await navigator.clipboard.writeText(value);
    message.success('Copiado al portapapeles');
  } catch (e) {
    message.error('No se pudo copiar');
  }
};
